import { render, staticRenderFns } from "./FinishFullTrivia.vue?vue&type=template&id=087515e6&scoped=true"
import script from "./FinishFullTrivia.vue?vue&type=script&lang=js"
export * from "./FinishFullTrivia.vue?vue&type=script&lang=js"
import style0 from "./FinishFullTrivia.vue?vue&type=style&index=0&id=087515e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "087515e6",
  null
  
)

export default component.exports